import { ShipstationIntegrationApiClient } from '@fourthwall/services/dist/ShipstationIntegrationApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateShipStationConfigurationMutation = createMutationHook(
  ShipstationIntegrationApiClient.updateShipstationConfiguration,
  {
    mutationKey: ['updateShipStationConfiguration'],
  },
)
